import { UsergroupAddOutlined, MedicineBoxOutlined } from '@ant-design/icons';
// icons
const icons = {
    UsergroupAddOutlined,
    MedicineBoxOutlined
};
const children = [
    {
        id: 'feedback',
        title: 'Feedback',
        type: 'collapse',
        url: '#',
        breadcrumbs: false,
        children: [
            {
                id: 'feedback',
                title: 'Feedback',
                type: 'item',
                url: '/dashboard/feedback',
                icon: icons.DashboardOutlined,
                breadcrumbs: false
            }
        ]
    }
];
const Feedback = {
    id: 'feedback',
    title: 'Feedback',
    type: 'group',
    icon: icons.MedicineBoxOutlined,
    children: children
};

export default Feedback;
